import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../lib/ep.js';

import ActionButton from '../components/builder/ActionButton';
import DownloadAppButton from '../components/builder/DownloadAppButton';
import FieldLabel from '../components/builder/FieldLabel';

import VideoEmbed from '../components/front/VideoEmbed';
import LeveledHTMLText from '../components/front/helpers/LeveledHTMLText.js';

function Autologin (props) {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props.promotion.Promotion;

	const default_login_introduction = `<h1>${i18n("Access")}</h1><p>${i18n("Identify yourself to participate.")}</p>`;
	const login_introduction = (promotion.login_introduction != undefined) ? promotion.login_introduction : default_login_introduction;

	const has_image_header = (isNotEmpty(promotion, 'full_login_image')) ? true : false;
	const has_video_header = (!has_image_header && promotion.login_video && promotion.login_video.url) ? true : false;

	let link_buttons = [];
	if(promotion.autologin_type == 'deep_links') {
		if(isNotEmpty(promotion, 'autologin_login_url')) {
			link_buttons.push({
				generic_label:"If you already have an account",
				label:"Login",
				_href:promotion.autologin_login_url,
				_target:'_blank',
				key:'login',
			});
		}

		if(isNotEmpty(promotion, 'autologin_register_url')) {
			link_buttons.push({
				generic_label:"If you still don't have an account",
				label:"Register",
				_href:promotion.autologin_register_url,
				_target:'_blank',
				key:'register',
			});
		}
	} else {
		if(isNotEmpty(promotion, 'autologin_external_url')) {
			link_buttons.push({
				label:"Go to page",
				_href:promotion.autologin_external_url,
				_target:'_blank',
				key:'goto',
			});
		}
	}

	let download_app_buttons = [];
	if(promotion.autologin_type == 'deep_links') {
		if(isNotEmpty(promotion, 'autologin_ios_app_url')) {
			download_app_buttons.push({
				platform:'ios',
				url:promotion.autologin_ios_app_url,
			});
		}

		if(isNotEmpty(promotion, 'autologin_android_app_url')) {
			download_app_buttons.push({
				platform:'android',
				url:promotion.autologin_android_app_url,
			});
		}
	}

	return (
		<div class="flex_cols">
			{(has_image_header || has_video_header) && (
				<div class="flex_col col_1">
					<div class="register_media_flex">
						{(has_image_header) && (
							<img src={promotion.full_login_image} style={{maxWidth:'100%'}} />
						)}

						{(has_video_header) && (
							<VideoEmbed
								video_url={promotion.login_video.url}
								video_thumb={promotion.login_video.image}
								autoplay={false}
							/>
						)}
					</div>
				</div>
			)}

			<div class="flex_col col_2">
				<div class="register_form_flex gui_main_text_color_on_bg" style={{width:'100%'}}>
					<LeveledHTMLText>{login_introduction}</LeveledHTMLText>

					{(link_buttons.length > 0 || download_app_buttons.length > 0) && (
						<ul class="gui_autologin_methods">
							{link_buttons.length > 0 && link_buttons.map((button) => {
								return (
									<li key={`link_button_${button.key}`}>
										<div>
											{(button.generic_label != undefined) && (
												<FieldLabel
													_class={{other:'adapt_as_general'}}
												>{button.generic_label}</FieldLabel>
											)}

											<div class="flex_button gui_big_button register_flex">
												<ActionButton
													_fullclass="mod_align_center"
													{...button}
												>{button.label}</ActionButton>
											</div>
										</div>
									</li>
								)
							})}

							{(download_app_buttons.length > 0) && (
								<li>
									<div>
										<FieldLabel
											_class={{other:'adapt_as_general'}}
										>Install our app</FieldLabel>

										<div class="gui_autologin_ctas">
											{download_app_buttons.map((button) => {
												return (
													<DownloadAppButton
														key={`button_${button.platform}`}
														{...button}
													/>
												)
											})}
										</div>
									</div>
								</li>
							)}
						</ul>
					)}
				</div>
			</div>
		</div>
	)
}

export default injectIntl(Autologin);